import React, { useEffect } from 'react'
import TableLayout from '../../components/TableLayout'
import Search from '../../components/Search'
import { Col, Row, Form, DatePicker, Statistic, Select, Typography, Button, Tooltip, Input, Icon, Spin } from 'antd'
import API from '../../services/API'
import { currencyFormat, methodCode } from '../../services/Utils'
const current = JSON.parse(localStorage.getItem('sucursal'))
import moment from 'moment'
const { Paragraph } = Typography

const { RangePicker } = DatePicker
const { Option } = Select

const ReportSalesContainer = props => {
    const [payments, setPayments] = React.useState([])
    const [period, setPeriod] = React.useState('day')
    const [subsidiary, setSubsidiary] = React.useState({
        id: current ? current.id : '',
        name: current ? current.name : '',
    })
    const [dateRange, setDateRange] = React.useState({
        startDate: moment(),
        endDate: moment().add(1, 'days'),
    })
    const [status, setStatus] = React.useState('')
    const [params, setParams] = React.useState('')
    const [loading, setLoading] = React.useState(true)

    const handleLoading = isLoading => {
        setLoading(isLoading)
    }

    const getParams = () => {
        let newParams = ''
        // let statusLocal = localStorage.getItem('status')
        if (subsidiary && subsidiary.id && subsidiary.id != 'all') {
            newParams += `&filter[subsidiary_id]=${subsidiary.id}`
        }
        if (dateRange.startDate && dateRange.endDate) {
            const endDate = `${dateRange.endDate.format('YYYY-MM-DD')} 23:59:59`
            newParams += `&dateRange=${dateRange.startDate.format('YYYY-MM-DD')}, ${endDate}`
        }
        if (customer && customer.id && customer.id != 'all') {
            newParams += `&filter[customer_id]=${customer.id}`
        }
        /*if (statusLocal && statusLocal != '0') {
            newParams += `&filter[order_status_id]=${statusLocal}`
        }*/
        setParams(newParams)
    }

    const [customer, setCustomer] = React.useState({ id: '', name: '' })

    const infoSales = (query = '') => {
        getParams()
        if (params) {
            API.get(`/api/orders/info_sales_report?${params}${query}`)
                .then(response => {
                    setPayments(response.data)
                })
                .catch(error => {
                    console.error(error)
                })
        }
    }

    const onChange = (reload = false, query = '') => {
        if (reload) {
            infoSales(query)
        }
    }

    const clean = () => {
        setPayments([])
        setPeriod('default')
        setSubsidiary({ id: current ? current.id : '', name: current ? current.name : '' })
        setCustomer({ id: '', name: '' })
        setStatus(null)
        localStorage.removeItem('filters')
    }

    React.useEffect(() => {
        const storedFilters = localStorage.getItem('filters')
        console.log('Ins storedFilters', storedFilters)
        if (storedFilters) {
            const { payments, period, subsidiary, dateRange, customer } = JSON.parse(storedFilters)
            setPayments(payments)
            setPeriod(period)
            setSubsidiary(subsidiary)
            setDateRange({
                startDate: moment(dateRange.startDate),
                endDate: moment(dateRange.endDate),
            })
            setCustomer(customer)
        }
    }, [])

    React.useEffect(() => {
        getParams()
        const filtersState = {
            payments,
            period,
            status,
            subsidiary: {
                id: subsidiary.id,
                name: subsidiary.name,
            },
            dateRange: {
                startDate: dateRange.startDate ? dateRange.startDate.format() : moment().format(),
                endDate: dateRange.endDate ? dateRange.endDate.format() : moment().format(),
            },
            customer: {
                id: customer.id,
                name: customer.name,
            },
        }
        localStorage.setItem('filters', JSON.stringify(filtersState))
    }, [customer, subsidiary.id, dateRange.startDate, dateRange.endDate, status])

    // Se agrega componente statusColumnFilter para trabajar con el filtro de estatus
    // const getColumnStatusProps = dataIndex => ({
    //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    //         <div style={{ padding: 8 }}>
    //             <Select
    //                 placeholder="Estatus"
    //                 optionFilterProp="children"
    //                 style={{ width: '100%', padding: 5 }}
    //                 filterOption={(input, option) =>
    //                     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    //                 }
    //                 onChange={key => {
    //                     console.log('key => ', key)
    //                     console.log('key', key);
    //                   if(key != '0'){
    //                         localStorage.setItem('status', key)
    //                         onChangeStatus(key)
    //                         getParams()
    //                         infoSales()
    //                     } else {
    //                         localStorage.setItem('status', '')
    //                         onChangeStatus('')
    //                         getParams()
    //                         infoSales()
    //                     }
    //                 }}
    //             >
    //                 <Option key="0" value="0">
    //                     Todos
    //                 </Option>
    //                 <Option key="1" value="1">
    //                     En Proceso
    //                 </Option>
    //                 <Option key="2" value="2">
    //                     Cancelado
    //                 </Option>
    //                 <Option key="4" value="4">
    //                     Entregado
    //                 </Option>
    //                 <Option key="5" value="5">
    //                     Facturado
    //                 </Option>
    //             </Select>
    //             <div>
    //                 {/* <Button
    //                     type="primary"
    //                     onClick={() => {
    //                         console.log('----', status, params)
    //                         confirm()
    //                     }}
    //                     icon="search"
    //                     size="small"
    //                     style={{ width: 90, marginRight: 8 }}
    //                 >
    //                     Buscar
    //                 </Button> */}
    //                 <Button onClick={() => {}} size="small"
    //                 //  style={{ width: 90 }}
    //                  style={{ width: 150 }}
    //                  >
    //                     Cancelar
    //                 </Button>
    //             </div>
    //         </div>
    //     ),
    //     filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    //     onFilterDropdownVisibleChange: visible => {
    //         if (visible) {
    //             setTimeout(() => {})
    //         }
    //     },
    // })

    // const onChangeStatus = newStatus => {
    //     setStatus(newStatus)
    // }

    const columns = [
        {
            title: 'ID único',
            dataIndex: 'unique_id',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Sucursal',
            dataIndex: 'subsidiary.name',
            sorter: false,
            filtered: false,
        },
        {
            title: 'Cliente',
            dataIndex: 'customer.social_reason',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Cajero',
            dataIndex: 'user.full_name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Cantidad',
            dataIndex: 'total_item_count',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Subtotal',
            dataIndex: 'sub_total',
            sorter: true,
            filtered: true,
            dataType: 'money',
        },
        {
            title: 'Impuestos',
            dataIndex: 'tax_amount',
            sorter: true,
            filtered: true,
            dataType: 'money',
        },
        {
            title: 'Total',
            dataIndex: 'grand_total',
            sorter: true,
            filtered: true,
            dataType: 'money',
        },

        {
            title: 'Fecha',
            dataIndex: 'captured_at',
            dataType: 'date',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Tipo de venta',
            dataIndex: 'is_credit',
            render: label => {
                return label == '1' ? 'Crédito' : 'Contado'
            },
        },
        {
            title: 'Estado',
            dataIndex: 'order_status_id',
            dataType: 'status',
            sorter: true,
            filtered: true,
            render: (label, record) => {
                if (record && record.status) {
                    return record.status.name
                }
                return ''
            },
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            sorter: false,
            filtered: false,
        },
    ]

    const getPaymentValue = name => Number(payments?.find(item => item.name === name)?.value || 0)

    const renderTotalsRow = (itemName, value, withTopBorder = false) => (
        <div
            key={itemName}
            style={{
                display: 'grid',
                gridTemplateColumns: '100px auto',
                whiteSpace: 'nowrap',
                borderTop: withTopBorder ? '2px solid #e8e8e8' : 'none',
            }}
        >
            <div>
                <Paragraph strong style={{ marginBottom: 0 }}>
                    {methodCode(itemName)}
                </Paragraph>
            </div>
            <div>
                <Paragraph strong style={{ marginBottom: 0 }}>
                    {currencyFormat(value)}
                </Paragraph>
            </div>
        </div>
    )

    return (
        <>
            <TableLayout
                title="Reporte de ventas"
                columns={columns}
                resource="v2/order"
                actions={['excel', 'pdf', 'show']}
                params={params}
                handleLoading={handleLoading}
                actionUrl={{
                  show:'/orders/show',
                }}
                additionalFilter={getData => (
                    <Row gutter={24}>
                        <Col lg={4} md={12} sm={24}>
                            <Form.Item label="Sucursal">
                                <Search
                                    value={subsidiary.name}
                                    placeholder="Sucursal"
                                    allOptions
                                    onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                    onChange={(key, value) => {
                                        setSubsidiary(value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={4} md={12} sm={24}>
                            <Form.Item label="Periodo">
                                <Select
                                    style={{ width: '100%' }}
                                    value={period}
                                    onChange={(key, value) => {
                                        switch (key) {
                                            case 'day':
                                                setDateRange({
                                                    startDate: moment(),
                                                    endDate: moment().add(1, 'days'),
                                                })
                                                break
                                            case 'week':
                                                setDateRange({
                                                    startDate: moment().startOf('week'),
                                                    endDate: moment().endOf('week'),
                                                })
                                                break
                                            case 'month':
                                                setDateRange({
                                                    startDate: moment().startOf('month'),
                                                    endDate: moment().endOf('month'),
                                                })
                                                break
                                            case 'year':
                                                setDateRange({
                                                    startDate: moment().startOf('year'),
                                                    endDate: moment().endOf('year'),
                                                })
                                                break
                                            default:
                                                break
                                        }

                                        setPeriod(key)
                                    }}
                                    placeholder="Periodo"
                                >
                                    <Option key="default" value="default">
                                        Seleccione un periodo
                                    </Option>
                                    <Option key="day" value="day">
                                        Día actual
                                    </Option>
                                    <Option key="week" value="week">
                                        Semana actual
                                    </Option>
                                    <Option key="month" value="month">
                                        Mes actual
                                    </Option>
                                    <Option key="year" value="year">
                                        Año actual
                                    </Option>
                                    <Option key="dayCustom" value="dayCustom">
                                        Dia Personalizado
                                    </Option>
                                    <Option key="custom" value="custom">
                                        Rango Personalizado
                                    </Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        {period == 'dayCustom' ? (
                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Fecha">
                                    <DatePicker
                                        style={{ width: 200, marginBottom: 10, display: 'block' }}
                                        value={dateRange.endDate}
                                        placeholder="Fecha"
                                        onChange={date => {
                                            setDateRange({
                                                startDate: date,
                                                endDate: date,
                                            })
                                        }}
                                        format="YYYY-MM-DD"
                                        onPressEnter={() => {}}
                                    />
                                </Form.Item>
                            </Col>
                        ) : null}
                        {period == 'custom' ? (
                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Rango de fechas">
                                    <RangePicker
                                        value={[dateRange.startDate, dateRange.endDate]}
                                        onChange={dateRange => {
                                            setDateRange({
                                                startDate: dateRange[0],
                                                endDate: dateRange[1],
                                            })
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        ) : null}
                        <Col lg={4} md={12} sm={24}>
                            <Form.Item label="Cliente">
                                <Search
                                    value={customer.social_reason}
                                    placeholder="Cliente"
                                    onSearch={value => `/api/customers?filter[q]=${value}`}
                                    label="social_reason"
                                    keyName="id"
                                    allOptions
                                    onChange={(key, value) => {
                                        setCustomer(value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={4} md={12} sm={24} style={{ paddingTop: '39.9999px' }}>
                            <Form.Item>
                                <Tooltip title="Limpiar" placement="top">
                                    <Button type="primary" style={{ marginRight: '5px' }} onClick={() => clean()}>
                                        Limpiar
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Buscar" placement="top">
                                    <Button type="primary" style={{ marginRight: '5px' }} onClick={getData}>
                                        Buscar
                                    </Button>
                                </Tooltip>
                            </Form.Item>
                        </Col>

                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'auto auto',
                                justifyContent: 'center',
                                gap: '20px',
                                paddingRight: '12px',
                                width: 'max-content',
                                maxWidth: 'none',
                            }}
                        >
                            {!loading ? (
                                <>
                                    <div style={{ display: 'grid', gridTemplateRows: 'repeat(8, 1fr)' }}>
                                        {[
                                            'debit_card',
                                            'credit_card',
                                            'cash',
                                            'transfer',
                                            'check',
                                            'credit',
                                        ].map(itemName => renderTotalsRow(itemName, getPaymentValue(itemName)))}
                                        {renderTotalsRow('total', getPaymentValue('total'), true)}
                                        {renderTotalsRow('total_invoiced', getPaymentValue('total_invoiced'))}
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateRows: 'repeat(1, 1fr)' }}>
                                        {renderTotalsRow('en_proceso', getPaymentValue('en_proceso'))}
                                    </div>
                                </>
                            ) : (
                                <Spin spinning={loading} marginBottom={10} marginRight={10} />
                            )}
                        </div>
                    </Row>
                )}
                onChange={onChange}
                shouldValidateParams={true}
            />
        </>
    )
}

export default ReportSalesContainer
